import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const PreviewWrapper = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, Object.assign({
    borderWidth: "100",
    borderStyle: "solid",
    borderColor: "border-core-subtle",
    borderRadius: "100",
    padding: "300"
  }, rest, {
    children: children
  }));
};